import { useMemo } from 'react';

export default function useComposerModeSuggestion({
  modeSuggestion,
  modeSuggestionAction,
}) {
  return useMemo(() => {
    if (modeSuggestionAction && typeof modeSuggestionAction === 'object') {
      return {
        modeSuggestion: modeSuggestion || null,
        modeSuggestionAction,
        fromFallback: false,
      };
    }
    return {
      modeSuggestion: modeSuggestion || null,
      modeSuggestionAction: null,
      fromFallback: false,
    };
  }, [modeSuggestion, modeSuggestionAction]);
}
